import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  getRowColData,
  validatedate_min_max,
  isValidItem,
  get_30DaysBack_FromCurrentDate,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiURL, fetchOutstandingReportDetail, fetchLedgerMaster } from "./API";

class OutstandingReport extends Component {
  state = {
    formData: {
      cmbType: "Customer",
      cmbName: "",
    },
    cmbTypeNames: [{ Types: "Customer" }, { Types: "Supplier" }],
    cmbNameItems: [],
    LedgerNameList: [],
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Outstanding Report";
    this.props.setActiveMenu("OutstandingReport");
    this.props.verifyUserID(
      this.loadNameItems,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  componentWillReceiveProps(newprops) {}
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  };
  //#endregion Handles

  //#region Function

  loadNameItems = () => {
    let reqData = {
      Op: "LedgerNameList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        this.setState({
          LedgerNameList: res.data.LedgerNameList,
        });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
    document.getElementById("cmbType").focus();
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validate = () => {
    let result = false;
    if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (
      !isValidItem(
        this.state.cmbTypeNames,
        "Types",
        this.state.formData.cmbType
      )
    ) {
      this.props.toastErrorMsg("Select Valid Type", "cmbType");
    } else if (
      this.state.formData.cmbName.length > 0 &&
      !isValidItem(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Name", "cmbName");
    } else {
      result = true;
    }
    return result;
  };

  reqDataForReport = (bolChkDataExist) => {
    return {
      Op: "OutstandingReport",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      ReportType: this.state.formData.cmbType,
      bolChkDataExist: bolChkDataExist,
      vac_name: this.state.formData.cmbName,
    };
  };

  openOutstandingReport = () => {
    if (this.validate()) {
      this.props.notifyProcessing();
      let reqData = this.reqDataForReport(true);
      fetchOutstandingReportDetail(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            let params = new URLSearchParams(reqData);
            let popupURL =
              apiURL + "outstandingreportdetail.php?" + params.toString();
            window.open(
              popupURL,
              "OutstandingReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
            document.getElementById("cmbType").focus();
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            document.getElementById("cmbType").focus();
          }
        })
        .catch((error) => {
          console.log(
            "Unknown error occurred in openAccountBookReport.",
            error
          );
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
    }
  };
  //#endregion Function

  render() {
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Outstanding Report</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={3}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbType"
                    label="Type"
                    items={this.state.cmbTypeNames}
                    colID="Types"
                    value={this.state.formData.cmbType}
                    handleOnChange={this.handleOnChange}
                    width={330}
                    maxLength={50}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbName"
                    // disabled={this.state.formData.cmbGroupNameDisabled}
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbName"
                    label="Name"
                    items={this.state.LedgerNameList}
                    colID="vac_ledgername"
                    width={330}
                    value={this.state.formData.cmbName}
                    handleOnChange={this.handleOnChange}
                    maxLength={50}
                    dataFilter={[
                      {
                        filterColID: "vac_backgroundprocess",
                        value: this.state.formData.cmbType,
                      },
                    ]}
                    onKeyDown={this.props.onKeyDown}
                    defaultAction={this.openOutstandingReport}
                  />
                </Grid>
                <Grid item>
                  <CtBtn
                    label="PDF"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.openOutstandingReport();
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(OutstandingReport))));
